


























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import { appFunc_callExit } from '@/utils/bridge'
@Component({
  name: 'guide',
  components: {}
})
export default class Guide extends Vue {
  created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  //返回
  handelback() {
    const from = this.$route.query.from as any
    if (from == 1) {
      appFunc_callExit()
    } else {
      this.$router.back()
    }
  }
}
